import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  EvaluationSheetResultFieldsFragment,
  SessionSummaryFieldsFragment, useGetSessionEvaluationSheetsResultsQuery,
} from '../../../../../../../../../../generated/core-api/graphql-react-query';
import withSessionDetailsSectionErrorBoundary from '../SessionDetailsSectionErrorBoundary';
import SessionEvaluationSheetDetailsDialog from './SessionEvaluationSheetDetailsDialog';
import SessionEvaluationSheetResultItem from './SessionEvaluationsheetResultItem';
import StyledBox from './styles';

interface SessionEvaluationSheetsProps {
  session: SessionSummaryFieldsFragment;
}

function SessionEvaluationSheets(props: SessionEvaluationSheetsProps) {
  const { session } = props;
  const { t } = useTranslation('session');
  const evaluationSheetResultsData = useGetSessionEvaluationSheetsResultsQuery({ input: { id: session.id }, inputOptions: { onlySession: !session.externalCallGroupId } }, { enabled: !!session.id });
  const [evaluationSheetDetails, setEvaluationSheetDetails] = React.useState<EvaluationSheetResultFieldsFragment | null>(null);
  const evaluationsSheetsResults = evaluationSheetResultsData.data?.getSession?.evaluationSheetResults ?? [];
  if (!evaluationsSheetsResults.length) {
    return null;
  }

  return (
    <StyledBox>
      <Box className="header">
        <Typography variant="subtitle1">
          {t('details.evaluation-sheets.title')}
        </Typography>
      </Box>
      <Box className="content">
        {evaluationsSheetsResults.map((sheet) => (
          <SessionEvaluationSheetResultItem
            key={sheet.id}
            sheet={sheet}
            setEvaluationSheetDetails={setEvaluationSheetDetails}
          />
        ))}
      </Box>
      {evaluationSheetDetails && (
        <SessionEvaluationSheetDetailsDialog sheetAssignmentId={evaluationSheetDetails.id} onClose={() => setEvaluationSheetDetails(null)} session={session} />
      )}
    </StyledBox>
  );
}

export default withSessionDetailsSectionErrorBoundary(SessionEvaluationSheets, 'session evaluation sheets');
